const API_BASE_URL = process.env.REACT_APP_API_URL

/**
 * Fetch all available currencies from the exchange rate API
 * @returns {Promise<Array>} Array of currency objects with code and name
 */
export const getAllCurrencies = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/exchange-rates/currencies`)

    if (!response.ok) {
      throw new Error("Failed to fetch currencies")
    }

    const data = await response.json()

    if (data.success && data.data && data.data.currencies) {
      return data.data.currencies
    }

    throw new Error("Invalid response format")
  } catch (error) {
    console.error("Error fetching currencies:", error)
    return []
  }
}
